// extracted by mini-css-extract-plugin
export default {"contentModal":"ManagerLayout_contentModal__sGAZj","titleModal":"ManagerLayout_titleModal__jFEnZ","closeButtonContainer":"ManagerLayout_closeButtonContainer__HPGd6"};